import * as React from 'react'
import {Link} from "gatsby";
import ServiceCard from "../../common/service-card";
import grzybicaPaznokciImg from '../../../images/podologia/grzybica-paznokci.png';
import kurzajkiImg from '../../../images/podologia/kurzajki.png';
import modzeleImg from '../../../images/podologia/modzele.png';
import odciskiImg from '../../../images/podologia/odciski.png';
import pekajacePietyImg from '../../../images/podologia/pekajace-piety.png';
import wrastajacyPaznokiecImg from '../../../images/podologia/wrastajacy-paznokiec.png';
import suchaSkoraImg from '../../../images/podologia/sucha-skora.png';

const PodologyProblems = () => {
    return (
        <div>
            <div className="row bg-white">
                <p className="text-center mb-1" data-sal="slide-down" data-sal-delay="200">
                    <h2 className="bb-primary pb-2 d-inline-block" data-sal="slide-down" data-sal-delay="300">Najczęstsze problemy podologiczne</h2>
                </p>
                <p className="text-center fs-5" data-sal="slide-down" data-sal-delay="200">
                    <Link to="/podologia/podstawowy-zabieg-podologiczny">
                        Podstawowy zabieg podologiczny
                    </Link> pozwala na kompleksową pielęgnację stóp. Gabinet
                    oferuje również szereg zabiegów specjalistycznych.
                </p>
                <div className="col pb-4" data-sal="slide-right" data-sal-delay="100">
                    <ServiceCard title="Odciski na stopach" img={odciskiImg} href="/podologia/odciski"/>
                </div>
                <div className="col pb-4" data-sal="slide-right" data-sal-delay="150">
                    <ServiceCard title="Wrastający paznokieć" img={wrastajacyPaznokiecImg} href="/podologia/wrastajacy-paznokiec"/>
                </div>
                <div className="col pb-4" data-sal="slide-right" data-sal-delay="200">
                    <ServiceCard title="Brodawki wirusowe (kurzajki)" img={kurzajkiImg} href="/podologia/brodawki-wirusowe"/>
                </div>
                <div className="col pb-4" data-sal="slide-right" data-sal-delay="250">
                    <ServiceCard title="Grzybica paznokci" img={grzybicaPaznokciImg} href="/podologia/grzybica-paznokci"/>
                </div>
                <div className="col pb-4" data-sal="slide-right" data-sal-delay="300">
                    <ServiceCard title="Zrogowacenia (modzele)" img={modzeleImg} href="/podologia/modzele"/>
                </div>
                <div className="col pb-4" data-sal="slide-right" data-sal-delay="350">
                    <ServiceCard title="Pękające pięty" img={pekajacePietyImg} href="/podologia/pekajace-piety"/>
                </div>
                <div className="col pb-4" data-sal="slide-right" data-sal-delay="400">
                    <ServiceCard title="Sucha skóra stóp" img={suchaSkoraImg} href="/podologia/sucha-skora"/>
                </div>
            </div>
            <div className="pb-5 text-center" data-sal="slide-down" data-sal-delay="200" data-sal-duration="400" data-sal-easing="ease-in-out-quint">
                <Link className="btn btn-secondary btn-lg mt-2" to="/podologia" role="button">
                    <i className="bi-card-checklist pe-2"></i> Zobacz pełną listę zabiegów
                </Link>
            </div>
        </div>
    )
}
export default PodologyProblems